import React, { RefObject, ReactElement, ForwardedRef } from 'react';
import ReactPhoneInput from 'react-phone-input-material-ui';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormHelper from '../form-helper/form-helper.component';
import FormatService from '../../services/format-service';
import useStylesFieldPhone from './field-phone.styles';
import { DATA_REF_NAME } from '../../constants/system/data-attributes';
import 'react-phone-input-material-ui/lib/style.css';
import './field-phone.styles.scss';

const FieldPhone: ReactMemoComponent = React.memo(React.forwardRef((
  props: ReactComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement => {
  const COUNTRY_CODE_DEFAULT: string = 'us';
  const PLACEHOLDER_DEFAULT: string = '9 (999) 999-9999';

  const {
    isOutlined,
    isBordered,
    isDisabled,
    withUnderline,
    withNoPlaceholder,
    withFormHelper,
    label,
    placeholder,
    className,
    onChange,
    inputRefIndex,
    inputRefs,
    input,
    meta,
    ...custom
  } = props;

  const {
    touched: isTouched,
    invalid: isInvalid,
    error: formError,
    submitError: formSubmitError,
    modifiedSinceLastSubmit,
  } = (meta || {}) as FormFieldMetaProps;

  const { classes } = useStylesFieldPhone();

  const withErrors: boolean = ((isTouched && isInvalid) || !!formError || !!formSubmitError)
    && !modifiedSinceLastSubmit;

  const borderedClassName: string | undefined = isBordered ? classes.fieldPhoneBordered : undefined;
  const outlinedClassName: string | undefined = isOutlined ? classes.fieldPhoneOutlined : undefined;
  const noUnderlineClassName: string | undefined = !withUnderline ? classes.fieldPhoneNoUnderline : undefined;

  return (
    <FormControl ref={ref} error={withErrors} className={classes.fieldPhoneFormControl}>
      <ReactPhoneInput
        disabled={isDisabled}
        disableDropdown={isDisabled || false}
        country={COUNTRY_CODE_DEFAULT}
        label={label || null}
        placeholder={PLACEHOLDER_DEFAULT}
        onChange={onChange}
        inputClass={FormatService.formatClassNames(
          classes.fieldPhone, borderedClassName, outlinedClassName, noUnderlineClassName, className,
        )}
        InputProps={{
          [DATA_REF_NAME]: inputRefIndex,
          error: isInvalid && isInvalid,
          helperText: isInvalid && withErrors && (formError || formSubmitError),
          maxLength: FormatService.STRING_LIMIT_DEFAULT,
          ref: (
            inputRefs && inputRefs.current ? (inputRef: RefObject<HTMLElement>): void => {
              inputRefs.current[inputRefIndex] = inputRef;
            } : null
          ),
        }}
        component={TextField}
        {...input}
        {...custom}
      />
      {
        withFormHelper && withErrors && (
          <FormHelper isTouched={isTouched} formError={formError || formSubmitError} />
        )
      }
    </FormControl>
  );
}));

export default FieldPhone;
